import * as React from 'react';
import { cn } from '@/lib/utils';

const PostForm = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-post-form',
      // Estilo base
      'flex w-full flex-wrap items-start justify-between gap-5 rounded-xl',
      className
    )}
    {...props}
  />
));
PostForm.displayName = 'PostForm';

export { PostForm };
